export default "/images/vendor/flag-icon-css/flags/4x3/hm.svg?fdd5197f75474534c5181648567dd633";